import { ITag } from "@/types/IBroadcastChannel";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IBroadCast {
  toggle: boolean;
  isTrenchDetail: boolean;
  searchText: string;
  selectedTags: ITag[];
  trenchTypeTags: ITag[];
}

const initialState: IBroadCast = {
  toggle: false,
  isTrenchDetail: false,
  searchText: "",
  selectedTags: [],
  trenchTypeTags: [],
};
export const Broadcast = createSlice({
  name: "broadcast_slice",
  initialState,
  reducers: {
    toggleReply: (state, action: PayloadAction<boolean>) => {
      state.toggle = action.payload;
    },
    setIsTrenchDetail: (state, action: PayloadAction<boolean>) => {
      state.isTrenchDetail = action.payload;
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setSelectedTagsInRedux: (state, action: PayloadAction<ITag[]>) => {
      state.selectedTags = action.payload;
    },
    setSelectedTrenchTypes: (state, action: PayloadAction<ITag[]>) => {
      state.trenchTypeTags = action.payload;
    },
  },
});

export const {
  toggleReply,
  setIsTrenchDetail,
  setSearchText,
  setSelectedTagsInRedux,
  setSelectedTrenchTypes,
} = Broadcast.actions;

export default Broadcast.reducer;
